export const RECEIVE_PAYMENT_TYPE = 'RECEIVE_PAYMENT_TYPE';
export const PRE_SUBMIT_BINDING = 'PRE_SUBMIT_BINDING';
export const SUBMIT_BINDING = 'SUBMIT_BINDING';
export const RECEIVE_FLOOR = 'RECEIVE_FLOOR';
export const RECEIVE_FLOOR_ALL = 'RECEIVE_FLOOR_ALL';
export const RECEIVE_PRICE_CATEGORY = 'RECEIVE_PRICE_CATEGORY';
